import { useAuth } from "@/contexts/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { Activity, LogOut, Upload, LayoutDashboard, User, TrendingUp, Shield } from "lucide-react";
import { useState } from "react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate("/auth");
  };

  return (
    <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/dashboard" className="flex items-center gap-2.5 group">
            <div className="w-8 h-8 rounded-lg bg-blue-900 flex items-center justify-center">
              <Activity className="w-4.5 h-4.5 text-white" size={18} />
            </div>
            <span className="font-semibold text-slate-900 text-lg" style={{ fontFamily: "Outfit, sans-serif" }}>
              LabReport <span className="text-blue-900">AI</span>
            </span>
          </Link>

          {/* Nav links */}
          <nav className="hidden sm:flex items-center gap-1">
            <Link to="/dashboard"
              className="flex items-center gap-1.5 px-3 py-2 text-sm text-slate-600 hover:text-blue-900 hover:bg-slate-50 rounded-md transition-colors">
              <LayoutDashboard size={15} /> Dashboard
            </Link>
            <Link to="/trends"
              className="flex items-center gap-1.5 px-3 py-2 text-sm text-slate-600 hover:text-blue-900 hover:bg-slate-50 rounded-md transition-colors">
              <TrendingUp size={15} /> Trends
            </Link>
            <Link to="/upload"
              className="flex items-center gap-1.5 px-3 py-2 text-sm text-slate-600 hover:text-blue-900 hover:bg-slate-50 rounded-md transition-colors">
              <Upload size={15} /> New Analysis
            </Link>
            {user?.role === "admin" && (
              <Link to="/admin"
                className="flex items-center gap-1.5 px-3 py-2 text-sm text-blue-900 hover:bg-blue-50 rounded-md transition-colors font-medium">
                <Shield size={15} /> Admin
              </Link>
            )}
          </nav>

          {/* User menu */}
          <div className="relative">
            <button
              data-testid="user-menu-button"
              onClick={() => setMenuOpen(!menuOpen)}
              className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-slate-50 transition-colors">
              <div className="w-7 h-7 rounded-full bg-blue-900 flex items-center justify-center">
                <User size={14} className="text-white" />
              </div>
              <span className="hidden sm:block text-sm text-slate-700 font-medium">{user?.name}</span>
            </button>

            {menuOpen && (
              <div className="absolute right-0 mt-1 w-48 bg-white border border-slate-200 rounded-lg shadow-lg z-50 py-1">
                <div className="px-4 py-2 border-b border-slate-100">
                  <p className="text-sm font-medium text-slate-900">{user?.name}</p>
                  <p className="text-xs text-slate-500 truncate">{user?.email}</p>
                  {user?.role === "admin" && (
                    <span className="text-xs font-semibold text-blue-800 bg-blue-50 px-1.5 py-0.5 rounded mt-1 inline-block">Admin</span>
                  )}
                </div>
                {user?.role === "admin" && (
                  <Link to="/admin" onClick={() => setMenuOpen(false)}
                    className="flex items-center gap-2 w-full px-4 py-2 text-sm text-blue-900 hover:bg-blue-50 transition-colors">
                    <Shield size={14} /> Admin Panel
                  </Link>
                )}
                <button
                  data-testid="logout-button"
                  onClick={handleLogout}
                  className="flex items-center gap-2 w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors">
                  <LogOut size={14} /> Sign out
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
